import { InjectionToken } from "@angular/core";
import { Resolve } from "@angular/router";
import { ILauncher } from "../../../../models/application/i-launcher";

export const launcherResolverInjectionToken: InjectionToken<Resolve<ILauncher>> = new InjectionToken<Resolve<ILauncher>>("digital-signage-developer-dashboard.LauncherResolver");
